import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import Cub from '../svg/Cub';
import Voln from '../svg/Voln';
import Img from '../01_atoms/Img';

const SeoText = ({ paragraph, title }) => {
  if (paragraph === null) {
    return null;
  }

  if (paragraph.description === null
    && (typeof paragraph.image === 'undefined' || paragraph.image === null)) {
    return null;
  }
  const image = Array.isArray(paragraph.image) ? paragraph.image[0] : null;

  return (
    <div className="add">
      <div className="wrapper">
        <div className="add__block">
          <div className="add__block--flex" data-aos="zoom-in" data-aos-delay="50" data-aos-duration="500">
            <Cub width="85" height="86" color="#f3f0f3" />
            <LazyLoad height={285} once>
              {image !== null && typeof image !== 'undefined'
              && <Img {...image} />}
            </LazyLoad>
          </div>
          <div className="add__block--flex">
            {title !== null && (
              <h1
                className="title_two font-weight-bold caps"
                data-aos="fade-down"
                data-aos-delay="30"
                data-aos-duration="500"
              >
                {title}
              </h1>
            )}
            <div
              className="formatted-text"
              dangerouslySetInnerHTML={{ __html: paragraph.description }}
            />
            <Voln />
          </div>
        </div>
      </div>
    </div>
  );
};

SeoText.propTypes = {
  paragraph: PropTypes.shape({
    description: PropTypes.string,
    image: PropTypes.arrayOf(PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string,
    })),
  }),
  title: PropTypes.string,
};

SeoText.defaultProps = {
  paragraph: null,
  title: null,
};

export default SeoText;
